import { InjectionToken } from '@angular/core';

export interface TokenInterceptorConfig {
  urls: string[];
}

export const SECURED_URLS = new InjectionToken<TokenInterceptorConfig>('TokenInterceptorConfig');
